import { render, staticRenderFns } from "./DFRRow.vue?vue&type=template&id=0faf5425&scoped=true"
import script from "./DFRRow.vue?vue&type=script&lang=js"
export * from "./DFRRow.vue?vue&type=script&lang=js"
import style0 from "./DFRRow.vue?vue&type=style&index=0&id=0faf5425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf5425",
  null
  
)

export default component.exports